import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';

export const TERMS_VERSION = '2026-08-14';
export const TERMS_STORAGE_KEY = 'pinnhub-terms-accepted-version';

export const hasAcceptedTerms = () => {
    try {
        return window.localStorage.getItem(TERMS_STORAGE_KEY) === TERMS_VERSION;
    } catch (_error) {
        return false;
    }
};

export const rememberTermsAcceptance = () => {
    try {
        window.localStorage.setItem(TERMS_STORAGE_KEY, TERMS_VERSION);
    } catch (_error) {
        // The Google flow still requires the checkbox when storage is unavailable.
    }
};

const TermsConsent = ({ checked, onChange }) => (
    <div>
        <FormControlLabel
            control={(
                <Checkbox
                    color="primary"
                    checked={checked}
                    onChange={onChange}
                    inputProps={{ 'aria-label': 'I agree to the PINN Hub Terms and Conditions' }}
                />
            )}
            label={(
                <Typography variant="body2">
                    I agree to the PINN Hub{' '}
                    <RouterLink to="/terms">Terms and Conditions</RouterLink>.
                </Typography>
            )}
        />
        <Typography variant="caption" color="textSecondary" display="block">
            Agent uploads stay private to your account, but may be retained and used for training, quality,
            safety, and reliability improvements. Do not upload secrets or data you are not authorized to share.
        </Typography>
    </div>
);

export default TermsConsent;
